module.exports = __webpack_public_path__ + "img/Certified_by_GS1_Logo.b13b58b7.png";